<script>
import ProfileSummary from '../components/ProfileSummary.vue'
import { mapGetters } from '../store'

export default {
    name: 'SettingsProfile',
    components: {
        ProfileSummary
    },
    computed: {
        ...mapGetters(['userResource'])
    },
    data() {
        return {
            loading: true,
            profileResource: null,
            previewModalVisible: false
        }
    },
    methods: {
        
    },
    async mounted() {
        this.profileResource = await this.userResource.getProfile()
        this.loading = false
    },
}
</script>

<template>
    <div v-page-title="'Profile'">
        <b-row>
            <b-col class="section-heading">
                <h4>Profile</h4>
                <hr />
            </b-col>
        </b-row>

        <div v-if="!loading">
            
            <b-row>
                <b-col>
                    <b-form-group label="Preview/Edit" description="Preview your profile and see exactly how hiring managers see your resume">
                        <b-button variant="secondary" @click="previewModalVisible = true">Preview Profile</b-button>
                        <b-button variant="primary" :to="{ name: 'settingsDeveloperProfile' }" class="ml-2">Edit Profile</b-button>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col>
                    <b-form-group label="Profile Visibility" description="Public profiles are not available yet">
                        <b-form-checkbox-group :checked="[1]">
                            <b-form-checkbox disabled :value="1">Private</b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-modal v-model="previewModalVisible" title="Preview Profile" size="xl" no-fade centered>
                <profile-summary :profile="profileResource" />
                <template #modal-footer>
                    <b-button variant="primary" @click="previewModalVisible = false">Done</b-button>
                    <b-button variant="secondary" :to="{ name: 'settingsDeveloperProfile' }">Edit Profile</b-button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<style scoped>

</style>
